import { render, staticRenderFns } from "./container-tabs.vue?vue&type=template&id=22ee5db2&scoped=true&"
import script from "./container-tabs.vue?vue&type=script&lang=js&"
export * from "./container-tabs.vue?vue&type=script&lang=js&"
import style0 from "./container-tabs.vue?vue&type=style&index=0&id=22ee5db2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ee5db2",
  null
  
)

export default component.exports